module.exports = __webpack_public_path__ + "img/drinks_audio.3e80aac9.jpg";